import {Box} from "@mui/material";
import {useTranslation} from "react-i18next";

interface Props {
    value: any;
    maxHeight?: number;
}

const MultilineText = ({value, maxHeight = 160}: Props) => {
    const {t} = useTranslation();

    const text =
        value === null || value === undefined || String(value).length === 0
            ? t("codetaskdetails.emptyOutput")
            : String(value);

    return (
        <Box
            component="pre"
            sx={(theme) => ({
                m: 0,
                mt: 0.5,
                p: 1.25,
                borderRadius: 1.5,
                border: `1px solid ${theme.palette.divider}`,
                backgroundColor:
                    theme.palette.mode === "dark"
                        ? "rgba(255,255,255,0.04)"
                        : "rgba(0,0,0,0.03)",
                color: theme.palette.text.primary,
                fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
                fontSize: 13,
                lineHeight: 1.45,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                maxHeight,
                overflow: "auto",
            })}
        >
            {text}
        </Box>
    );
};

export default MultilineText;